<template>
  <footer>
    <div>
      <div class="copyright">
        <p>
          &copy; Roadink GLB © {{ new Date().getFullYear() }}. All Rights
          Reserved
        </p>
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank" class="icp"
            >粤ICP备2025481464号-2</a
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
footer {
  background-color: #022a4e;
  color: white;
  padding: 40px 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.footer-column h4 {
  margin-bottom: 20px;
  font-size: 18px;
}

.footer-column ul {
  list-style: none;
}

.footer-column li {
  margin-bottom: 10px;
}

.footer-column a {
  color: #b3cde0;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  color: white;
}

.copyright {
  text-align: center;
  padding-top: 20px;
  color: #b3cde0;
  font-size: 14px;
}

.icp {
  color: #b3cde0;
}
</style>